module.exports = __webpack_public_path__ + "img/img30.077e3618.png";